import request from '../../axios';

const PatchMachineryRequirement = async (
  payload: IMachineryRequirementPayload,
  guid?: string,
) => {
  const newPayload = {
    brs_type: payload.srs_type?.type,
    sub_input: payload.sub_input?.guid,
    title: payload.title,
    location: `POINT (${payload.location?.lng} ${payload.location?.lat})`,
    wanted_number: payload.wanted_number,
    cultivation: payload.cultivation?.guid,
    only_massage_buyer: payload.only_massage_buyer || false,
    requirement_during: payload?.requirement_during,
    request_date_unit: payload?.request_date_unit?.value,
    is_change_title: payload?.is_change_title,
    ad_price: payload.ad_price,
    filter: 'requirement',
  };
  const response = await request.patch(`api/v2/store/advertisement/${guid}`, {
    ...newPayload,
  });

  return response.data;
};

export default PatchMachineryRequirement;
